import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const PILLARS = [
  {
    index: "01",
    accent: "from-primary-container to-transparent",
    numColor: "text-primary",
    linkColor: "text-primary hover:text-on-primary-container",
    title: "Attack Surface Intelligence",
    desc: "Discovers and continuously monitors every internet-facing domain, IP, API, and cloud resource before an attacker finds it.",
    to: "/asm",
    cta: "Explore ASI",
  },
  {
    index: "02",
    accent: "from-secondary-container to-transparent",
    numColor: "text-secondary",
    linkColor: "text-secondary hover:text-on-secondary-fixed-variant",
    title: "Digital Risk Intelligence",
    desc: "Watches the dark web, leak sites, and social platforms so external threats outside the firewall don't turn into a breach.",
    to: "/dri",
    cta: "Explore DRI",
  },
  {
    index: "03",
    accent: "from-primary-container via-surface-variant to-secondary-container",
    numColor: "text-on-surface dark:text-surface-bright",
    linkColor: "text-on-surface dark:text-surface-bright hover:text-on-surface-variant",
    title: "Compliance & Cloud Security",
    desc: "Continuously checks cloud posture against frameworks (SOC 2, ISO 27001) with prioritized, evidence-backed remediation.",
    to: "/compliance",
    cta: "Explore Compliance",
  },
];

export default function PillarsTeaser() {
  return (
    <section className="w-full px-gutter max-w-container-max mx-auto mb-section-gap">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-stack-lg"
      >
        <span className="font-eyebrow text-eyebrow text-primary uppercase tracking-widest block mb-2">
          One Platform
        </span>
        <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright">
          Three Modules. One Risk Score.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {PILLARS.map((p, i) => (
          <motion.div
            key={p.to}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45, delay: i * 0.1, ease: "easeOut" }}
          >
            <Link
              to={p.to}
              className="block bg-surface-card-light dark:bg-surface-card-dark backdrop-blur-lg border border-glass rounded-xl p-card-padding relative overflow-hidden group hover:-translate-y-1 transition-all duration-300 shadow-sm hover:shadow-md h-full"
            >
              <div className={`absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r ${p.accent}`} />
              <span className={`font-data-mono text-data-mono mb-4 block ${p.numColor}`}>{`${p.index} //`}</span>
              <h3 className="font-headline-card text-headline-card text-on-surface dark:text-surface-bright mb-3">
                {p.title}
              </h3>
              <p className="font-body-md text-body-md text-on-surface-variant dark:text-surface-variant mb-6">
                {p.desc}
              </p>
              <span className={`inline-flex items-center gap-1 font-label-sm text-label-sm transition-colors uppercase ${p.linkColor}`}>
                {p.cta} <span className="material-symbols-outlined text-[16px]">arrow_forward</span>
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
